import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import { Input, Form, Radio } from 'antd';
import FormSteps from '../Form/Form';


const RedditoMensile = () => {

    const tipologiaAttivita = useSelector(state => state.dataReducer.modello.datiPratica.attivita);

    const ErroriSalvaStep = useSelector(state => state.dataReducer.salvaStep.dati);

    const [errorMessageRedditoMensile, setErrorMessageRedditoMensile] = useState(null);
    const [errorMessageRedditoMensilita, setErrorMessageRedditoMensilita] = useState(null);

    useEffect(() => {
        if(ErroriSalvaStep){
            ErroriSalvaStep.forEach(errore => {
                switch(errore.errorCode) {
                    case "redditoMensileNetto":
                        setErrorMessageRedditoMensile(errore.errorMessage);
                    break;
                    case "redditoMensilita":
                        setErrorMessageRedditoMensilita(errore.errorMessage);
                    break;
                    default:
                        setErrorMessageRedditoMensile(null);
                        setErrorMessageRedditoMensilita(null);
                    break;
                }
            });
        }else{
            setErrorMessageRedditoMensile(null);
            setErrorMessageRedditoMensilita(null);
        }
    }, [ErroriSalvaStep]);

    function controlloNumber(e){
        if (['e', 'E', '+', '-'].includes(e.key)) {
            e.preventDefault();
            return false;
        }
    }
    
    return (
        <div className={stylesForm.Form}>

            <HeaderStep titolo='Reddito' 
                        sottotitolo ='' />

            <FormSteps formId="step10" >

            <Form.Item name="redditoMensileNetto"  help={errorMessageRedditoMensile ? errorMessageRedditoMensile : null }
                        rules={[
                            {
                                required: true,
                                message: 'Imposta il reddito mensile netto',
                            },
                            {
                                max: 5,
                                message: 'Il reddito mensile non può superare i 5 caratteri',
                            }
                        ]}
                        >
                        <Input type='text' onChange={controlloNumber} maxLength={5} placeholder='redditoMensileNetto' prefix={`€`} suffix={<label className={`${stylesForm.floatingLabel} ${stylesForm.floatingLabelInputNumber}`}  htmlFor="redditoMensileNetto">Reddito mensile netto*</label>} />
            </Form.Item>

            {
                tipologiaAttivita === 'D' ? (

                    <>
                    <label className={stylesForm.floatingLabel} htmlFor="redditoMensilita">Mensilità*</label>
                    <Form.Item name="redditoMensilita" help={errorMessageRedditoMensilita}
                                rules={[
                                {
                                    required: true,
                                    message: 'Scegli le mensilità',
                                }
                                ]}
                    >
                        <Radio.Group >
                            <Radio.Button value={12} className={stylesForm.threeRadioButton}>12</Radio.Button>
                            <Radio.Button value={13} className={stylesForm.threeRadioButton}>13</Radio.Button>
                            <Radio.Button value={14} className={stylesForm.threeRadioButton}>14</Radio.Button>
                        </Radio.Group>
                    </Form.Item>
                    </>

                ) : null
            }

            </FormSteps>
        </div>
    )
}

export default RedditoMensile;